module.exports = __webpack_public_path__ + "static/media/exchange-btn@2x.c7ba3094.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/exchange-btn@2x.png
// module id = 202
// module chunks = 1